import React from "react";
import { Typography, Box } from "@mui/material";
import {
  ThemeProvider,
  StyledEngineProvider,
  useTheme
} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import ellipseBgImg from "../../assets/svgs/headerCalendar.svg";

import learningCenterDarkTheme from "../../theme/learningCenterDarkTheme";
const useStyles = makeStyles(theme => ({
  header: {
    backgroundImage: `url(${ellipseBgImg})`,
    backgroundSize: "cover",
    width: "100%",
    color: theme.palette.common.white,
    display: "flex",
    alignItems: "center"
  }
}));

function FullPageLayoutWithHeader(props) {
  const { title, headerActions, children } = props;
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={learningCenterDarkTheme(theme)}>
          <Box display="flex" flexDirection="column" width="100%">
            <Box className={classes.header} px={{ xs: 3, sm: 6 }} py={1}>
              <Box
                display="flex"
                justifyContent={{ xs: "center", sm: "space-between" }}
                alignItems="center"
                flex={1}
                flexWrap="wrap"
              >
                <Box pt={{ xs: 3, sm: 5.25 }} pb={{ xs: 1, sm: 5.25 }}>
                  <Typography variant="h2">{title}</Typography>
                </Box>
                {headerActions && (
                  <Box alignSelf="flex-end">{headerActions}</Box>
                )}
              </Box>
            </Box>
          </Box>
        </ThemeProvider>
      </StyledEngineProvider>
      {children}
    </Box>
  );
}

export default FullPageLayoutWithHeader;
